<template>
	<div class="main-mensajeria-checkout">


		<!--Contenido de otro servicio-->
		<div class="other-service" v-show="status_other">
			<div class="header-other-service">
				<i class="fas fa-times" @click="Close()"></i>
			</div>
			<div class="icon" v-bind:style="{backgroundColor : color_licencia }">
				<img src="https://info.vinapp.co/wp-content/uploads/2021/04/team-1.png" alt="">
			</div>
			<label>Describe el servicio que necesitas</label>
			<input type="text" placeholder="Nombres" autocomplete="off" class="general" v-model="form_other.other_name">
			<input type="text" placeholder="Teléfono" autocomplete="off" class="general" v-model="form_other.other_phone">
			<input type="text" class="other-input" autocomplete="off" placeholder="Describe..." v-model="form_other.other_service">
			<button class="send-wp" v-bind:style="{backgroundColor : color_licencia }" @click="saveBD()"><i class="fab fa-whatsapp"></i> Enviar a WhatsApp</button>
		</div>



		<!--Contenido del formulario de comprar algo-->
		<div class="send-deliver" v-show="status_delivery">
			<div class="header-deliver">
				<h4>Comprar algo</h4>
				<i class="fas fa-times" @click="Close()"></i>
			</div>
			<div class="deliver-inputs">
				<div class="primary-info">
					<div class="name">
						<input type="text" class="general" placeholder="Tú nombre" autocomplete="off" v-model="buy_form.buy_name">
					</div>
					<div class="phone">
						<input type="text" class="general"  placeholder="Tú teléfono" autocomplete="off" v-model="buy_form.buy_phone">
					</div>					
				</div>
				
				<input type="text" class="general" placeholder="¿Donde compramos?" autocomplete="off" v-model="buy_form.where_buy">

				<input type="text" class="general" placeholder="¿Que vamos a comprar?" autocomplete="off" v-model="buy_form.buy_order">

				<input type="text" class="general" placeholder="Precio aproximado" autocomplete="off" v-model="buy_form.buy_price">

				<input type="text" class="general" placeholder="¿Donde te lo llevamos?" autocomplete="off" v-model="buy_form.buy_address">

				<label class="payment">Métodos de pago</label>
				<div class="payment-way">
					<div class="pay-icon" v-bind:style="{backgroundColor : color_licencia }">
						<i class="fas fa-money-bill"></i>
					</div>
					<div class="pay-select">
						<select name="select" v-model="buy_form.id_payment" @change="payment()">
							<option value="0" disabled selected>Seleccione...</option>
							<option value="37" v-if="cash">Efectivo</option>
							<option value="38" v-if="transfer">Transferencia</option>
							<option value="39"  v-if="dataphone">Datáfono</option>
						</select>
					</div>
				</div>
				<select name="select" id="select-bank" @change="copyAccount()" v-show="transer_state && bank_account.length > 0">
					<option value="0" disabled selected>Seleccione para copiar N° de cuenta</option>
					<option :value="bank.account" v-for="bank in bank_account" :key="bank.id">{{ bank.bank }}</option>
				</select>
				<div class="transfer-container" v-if="success">
					<h4 class="transfer-text">¡Numero de cuenta copiado!</h4>
				</div>
				<label class="payment3">Observaciones adicionales</label>
				<input type="text" class="detail-text" autocomplete="off" placeholder="Opcional" v-model="buy_form.buy_info">
			</div>
			<div class="more-options">
				<h4 class="first-question">Programar fecha</h4>
				<label class="switch" @click="verifyBuy()">
  					<input type="checkbox" id="select5">
 					<span class="slider round"></span>
				</label>
			</div>
			<div class="fecha-hora" v-if="buy_state">
				<div class="date-select">
					<label class="payment2">Fecha de entrega</label>
					<input type="date" class="deliver-day" v-model="buy_form.b_date" placeholder="Seleccione..." autocomplete="off" onchange="this.className=(this.value!=''?'has-value':'')">
				</div>
				<div class="hour-select">
					<label class="payment2">Hora de entrega</label>
					<input type="time" class="deliver-hour" v-model="buy_form.b_hour" placeholder="Seleccione..." autocomplete="off" onchange="this.className=(this.value!=''?'has-value':'')">
				</div>
			</div>
			<button class="send-wp" v-bind:style="{backgroundColor : color_licencia }" @click="saveBD()"><i class="fab fa-whatsapp"></i> Enviar a WhatsApp</button>
		</div>




		<!--Contenido del formulario de recoger algo-->
		<div class="get-something" v-show="status_get">
			<div class="header-get">
				<h4>Recoger algo</h4>
				<i class="fas fa-times" @click="Close()"></i>
			</div>
			<div class="inputs-info">
				<div class="primary-info">
					<div class="name">
						<input type="text" class="general" placeholder="Nombres" v-model="get_form.get_name">
					</div>
					<div class="phone">
						<input type="text" class="general"  placeholder="Teléfono" v-model="get_form.get_phone">
					</div>
				</div>
				<input type="text" class="general" placeholder="Email" v-show="status_email" v-model="get_form.get_email">
				<input type="text" class="general" placeholder="Dirección de recogida" v-model="get_form.get_address">
				<!--<input type="text" class="general" placeholder="¿Donde quieres comprar?" v-model="get_form.buy_place">-->
				<label class="payment3">¿A donde se lleva?</label>
				<!--<input type="text" class="general" placeholder="Dirección" v-model="get_form.place_address">-->
				<input list="get_directions" name="get_direction" class="general" id="get_direction" placeholder="Dirección" v-model="get_form.place_address">
				<datalist id="get_directions">
					<option :value="item" v-for="item in direction_get_list">{{item}}</option>
				</datalist>
				<input type="text" class="general" placeholder="Preguntar por" v-model="get_form.who_asked">
				<label class="payment">Métodos de pago</label>
				<div class="payment-way">
					<div class="pay-icon" v-bind:style="{backgroundColor : color_licencia }">
						<i class="fas fa-money-bill"></i>
					</div>
					<div class="pay-select">
						<select name="select" v-model="get_form.payment_id" @change="payment()">
							<option value="0" disabled selected>Seleccione...</option>
							<option value="37" v-if="cash">Efectivo</option>
							<option value="38" v-if="transfer">Transferencia</option>
							<option value="39"  v-if="dataphone">Datáfono</option>
						</select>
					</div>
				</div>
				<select name="select" id="select-bank" @change="copyAccount()" v-show="get_state && bank_account.length > 0">
					<option value="0" disabled selected>Seleccione para copiar N° de cuenta</option>
					<option :value="bank.account" v-for="bank in bank_account" :key="bank.id">{{ bank.bank }}</option>
				</select>
				<div class="transfer-container" v-if="success">
					<h4 class="transfer-text">¡Numero de cuenta copiado!</h4>
				</div>
				<label class="payment3">Danos más detalles</label>
				<input type="text" class="detail-text" placeholder="Opcional" v-model="get_form.more_details">
			</div>
			<div class="more-options">
				<h4 class="first-question">Programar fecha</h4>
				<label class="switch" @click="hideFields()">
  					<input type="checkbox" id="select4">
 					<span class="slider round"></span>
				</label>
			</div>
			<div class="fecha-hora" v-if="programado_state">
				<div class="date-select">
					<label class="payment2">Fecha de entrega</label>
					<input type="date" class="deliver-day" v-model="get_form.date" placeholder="Seleccione..." autocomplete="off" onchange="this.className=(this.value!=''?'has-value':'')">
				</div>
				<div class="hour-select">
					<label class="payment2">Hora de entrega</label>
					<input type="time" class="deliver-hour" v-model="get_form.hour" placeholder="Seleccione..." autocomplete="off" onchange="this.className=(this.value!=''?'has-value':'')">
				</div>
			</div>
			<button class="send-wp" v-bind:style="{backgroundColor : color_licencia }" @click="saveBD()"><i class="fab fa-whatsapp"></i> Enviar a WhatsApp</button>
		</div>


		<!--Contenido del formulario de enviar algo-->
		<div class="send-something" v-show="status_send">
			<div class="header-send">
				<h4>Enviar algo</h4>
				<i class="fas fa-times" @click="Close()"></i>
			</div>
			
			<label class="payment">Lugar de recogida</label>
			<input type="text" class="general" placeholder="Preguntar por" v-model="send_form.recogida_persona">
			<input type="text" class="general" placeholder="Dirección" v-model="send_form.recogida_direccion">
			<input type="text" class="general" placeholder="Correo electronico" v-show="status_email" v-model="send_form.recogida_email">
			<input type="text" class="general" placeholder="Teléfono" v-model="send_form.recogida_telefono">
			<label class="payment">¿A donde se lleva?</label>
			<input type="text" class="general" placeholder="Preguntar por" v-model="send_form.where_persona">
			<input list="directions" name="direction" class="general" id="direction" placeholder="Dirección" v-model="send_form.where_direccion">
			<input type="text" class="general" placeholder="Teléfono" v-model="send_form.where_telefono">
			<datalist id="directions">
				<option :value="item" v-for="item in direction_list">{{item}}</option>
			</datalist>
			<!--<div class="option-check">
				<div class="checkbox1">
					<div class="inputGroup" @click="send_form.go_and_back = true;send_form.no_go_and_back = false">					
		   				<input type="checkbox" v-model="send_form.go_and_back"/>
		   				<label for="option1">Si</label>
	  				</div>
				</div>
				<div class="checkbox2">
					<div class="inputGroup" @click="send_form.no_go_and_back = true; send_form.go_and_back=false">					
		   				<input type="checkbox" v-model="send_form.no_go_and_back"/>
		   				<label for="option1">No</label>
	  				</div>
				</div>
			</div>-->
			<!--<h4 class="second-question">Disponibilidad</h4>
			<div class="avaliable-check">				
				<div class="checkbox3" @click="programado = true;send_form.programming_date = true;send_form.inmediatly = false">
					<div class="inputGroup2">					
		   				<input  type="checkbox" v-model="send_form.programming_date"/>
		   				<label for="option4">Programar fecha</label>
	  				</div>
				</div>
				<div class="checkbox4" @click="programado = false;send_form.inmediatly = true; send_form.programming_date = false">
					<div class="inputGroup2">					
		   				<input type="checkbox" v-model="send_form.inmediatly"/>
		   				<label for="option4">Inmediata</label>
	  				</div>
				</div>
			</div>-->
			
			<label class="payment">Métodos de pago</label>
			<div class="payment-way">
				<div class="pay-icon" v-bind:style="{backgroundColor : color_licencia }">
					<i class="fas fa-money-bill"></i>
				</div>
				<div class="pay-select">
					<select name="select" v-model="send_form.payment_way" @change="payment()">
						<option value="0" disabled selected>Seleccione...</option>
						<option value="37" v-if="cash">Efectivo</option>
						<option value="38" v-if="transfer">Transferencia</option>
						<option value="39"  v-if="dataphone">Datáfono</option>
					</select>
				</div>
			</div>
			<select name="select" id="select-bank" @change="copyAccount()" v-show="bank_transfer && bank_account.length > 0">
				<option value="0" disabled selected>Seleccione para copiar N° de cuenta</option>
				<option :value="bank.account" v-for="bank in bank_account" :key="bank.id">{{ bank.bank }}</option>
			</select>
			<div class="transfer-container" v-if="success">
					<h4 class="transfer-text">¡Numero de cuenta copiado!</h4>
				</div>
			<label class="payment3">Información adicional</label>
			<input type="text" class="detail-text" placeholder="Opcional" v-model="send_form.additional_info">
			<div class="more-options">
				<h4 class="first-question">Más opciones</h4>
				<label class="switch" @click="validateOptions()">
  					<input type="checkbox" id="select3">
 					<span class="slider round"></span>
				</label>
			</div>
			<div class="send-back" v-if="status_option">
				<h4 class="first-question">¿Es ida y vuelta?</h4>
				<label class="switch" @click="validateSend()">
  					<input type="checkbox" id="select2">
 					<span class="slider round"></span>
				</label>	
			</div>
			<div class="programming-date" v-if="status_option">
				<h4 class="first-question">Programar fecha</h4>
				<label class="switch"  @click="validateCheck()">
  					<input type="checkbox" id="select">
 					<span class="slider round"></span>
				</label>	
			</div>
			<div class="fecha-hora" v-if="programado">
				<div class="date-select">
					<label class="payment2">Fecha de entrega</label>
					<input type="date" class="deliver-day" v-model="send_form.deliver_date" placeholder="Seleccione..." autocomplete="off" onchange="this.className=(this.value!=''?'has-value':'')">
				</div>
				<div class="hour-select">
					<label class="payment2">Hora de entrega</label>
					<input type="time" class="deliver-hour" v-model="send_form.deliver_hour" placeholder="Seleccione..." autocomplete="off" onchange="this.className=(this.value!=''?'has-value':'')">
				</div>
			</div>
			<button class="send-wp" v-bind:style="{backgroundColor : color_licencia }"  @click="saveBD()"><i class="fab fa-whatsapp"></i> Enviar a WhatsApp</button>
		</div>
	</div>
</template>

<style lang="scss" type="text/css" scoped>

	@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

	.transfer-text{
		font-size: 15px;
		color: green;
	}

	.hide{
		display: none !important;
	}

	#select-bank{
		width: 100%;
		padding: 12px 10px;
		border: 1px solid #DFDFDF;
		font-family: 'Poppins', sans-serif;
		font-size: 15px;
		background: transparent;
		margin-bottom: 10px;
	}

	.other-input{
		width: 100%;
		height: 120px;
		border-top-left-radius: 5px;
		border-bottom-left-radius: 5px;
		border-bottom-right-radius: 5px;
		background: #F8F6FB;
		border: 1px solid #cccccc;
		margin-bottom: 15px;
		padding: 14px 15px;
	}

	.switch {
	  position: relative;
	  display: inline-block;
	  width: 60px;
	  height: 29px;
	}

	.switch input { 
	  opacity: 0;
	  width: 0;
	  height: 0;
	}

	.slider {
	  position: absolute;
	  cursor: pointer;
	  top: 0;
	  left: 0;
	  right: 0;
	  bottom: 0;
	  background-color: #ccc;
	  -webkit-transition: .4s;
	  transition: .4s;
	}

	.slider:before {
	  position: absolute;
	  content: "";
	  height: 21px;
	  width: 21px;
	  left: 4px;
	  bottom: 4px;
	  background-color: white;
	  -webkit-transition: .4s;
	  transition: .4s;
	}

	input:checked + .slider {
	  background-color: #2196F3;
	}

	input:focus + .slider {
	  box-shadow: 0 0 1px #2196F3;
	}

	input:checked + .slider:before {
	  -webkit-transform: translateX(26px);
	  -ms-transform: translateX(26px);
	  transform: translateX(26px);
	}

	/* Rounded sliders */
	.slider.round {
	  border-radius: 34px;
	}

	.slider.round:before {
	  border-radius: 50%;
	}


	.send-back{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.more-options{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-bottom: 15px;
	}

	.programming-date{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-top: 10px;
	}

	*:focus{
		outline: none;
	}

	.header-other-service{
		width: 100%;
		padding: 10px;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin-bottom: 15px;
	}

	.other-service{
		width: 100%;
		height: auto;
		padding: 20px;
		text-align: center;
	}

	.other-service label{
		font-size: 18px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		margin-top: 15px;
		margin-bottom: 20px;
	}


	.icon{
		width: 150px;
		border-radius: 50%;
		padding: 30px;
		margin: 0 auto;
		box-shadow: 0px 0px 14px 0px rgba(237,237,237,1);
	}

	.icon img{
		width: 100%;
		height: auto;
	}

	.send-wp{
		width: 100%;
		padding: 15px;
		border: none;
		margin-top: 15px;
		color: #fff;
		font-size: 17px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
	}

	.primary-info{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.name, .phone{
		width: 48%;
	}

	.general{
		width: 100%;
		border-top-left-radius: 5px;
		border-bottom-left-radius: 5px;
		border-bottom-right-radius: 5px;
		background: #F8F6FB;
		border: 1px solid #cccccc;
		margin-bottom: 15px;
		padding: 14px 15px;
		/*box-shadow: 0px 8px 10px 0px rgba(230,230,230,1);*/
	}

	.detail-text{
		width: 100%;
		border-top-left-radius: 5px;
		border-bottom-left-radius: 5px;
		border-bottom-right-radius: 5px;
		background: #F8F6FB;
		border: 1px solid #cccccc;
		margin-bottom: 15px;
		padding-top: 14px;
		padding-bottom: 60px;
		padding-left: 15px;
		padding-right: 15px;
	}

	.fecha-hora{
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.date-select, .hour-select{
		width: 50%;
	}

	.deliver-hour, .deliver-day{
		padding: 13px;
		border-top-left-radius: 22px;
		border-bottom-right-radius: 22px;
		border-bottom-left-radius: 22px;
		border: 1px solid #cccccc;
		font-size: 15px;
		width: 95%;
		background: #fff;
	}

	input[type="date"].has-value{
  		width:95% !important;
  		padding: 13px;
		border-top-left-radius: 22px;
		border-bottom-right-radius: 22px;
		border-bottom-left-radius: 22px;
		border: 1px solid #cccccc;
		font-size: 15px;
		width: 95%;
		background: #fff;
	}

	input[type="time"].has-value{
  		width:95% !important;
  		padding: 13px;
		border-top-left-radius: 22px;
		border-bottom-right-radius: 22px;
		border-bottom-left-radius: 22px;
		border: 1px solid #cccccc;
		font-size: 15px;
		width: 95%;
		background: #fff;
	}

	input[type="date"]:not(.has-value):before{
  		color: #757575;
 		content: attr(placeholder);
	}

	input[type="time"]:not(.has-value):before{
  		color: #757575;
 		content: attr(placeholder);
	}

	*:focus{
		outline: none;
	}

	.payment{
		padding-top: 15px;
		font-size: 17px;
		font-family: 'Poppins', sans-serif;
	}

	.payment2{
		padding-top: 15px;
		font-size: 15px;
		font-family: 'Poppins', sans-serif;
	}

	.payment3{
		padding-top: 5px;
		font-size: 15px;
		font-family: 'Poppins', sans-serif;
	}
	
	.send-something{
		width: 100%;
		height: auto;
		padding: 20px;	
		text-align: left;
	}

	.get-something{
		width: 100%;
		height: auto;
		padding: 20px;	
		text-align: left;
	}

	.send-deliver{
		width: 100%;
		height: auto;
		padding: 20px;	
		text-align: left;
	}

	.option-check{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.avaliable-check{
		width: 100%;
		display: block;
	}

	.checkbox1, .checkbox2{
		width: 48%;
	}

	.inputGroup {
	    background-color: #fff;
	    border: 1px solid #D1D7DC;
	    display: block;
	    margin: 0;
	    position: relative;
	    width: 100%;
	    label {
	      padding: 12px 30px;
	      width: 100%;
	      display: block;
	      text-align: left;
	      margin-bottom: 0 !important;
	      color: #3C454C;
	      font-size: 15px;
	      font-family: 'Poppins', sans-serif;
	      cursor: pointer;
	      position: relative;
	      z-index: 2;
	      transition: color 200ms ease-in;
	      overflow: hidden;

	      &:before {
	        width: 10px;
	        height: 10px;
	        border-radius: 50%;
	        content: '';
	        background-color: #5562eb;
	        position: absolute;
	        left: 50%;
	        top: 50%;
	        transform: translate(-50%, -50%) scale3d(1, 1, 1);
	        transition: all 300ms cubic-bezier(0.4, 0.0, 0.2, 1);
	        opacity: 0;
	        z-index: -1;
	      }

	      &:after {
	        width: 32px;
	        height: 32px;
	        content: '';
	        border: 2px solid #D1D7DC;
	        background-color: #fff;
	        background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.414 11L4 12.414l5.414 5.414L20.828 6.414 19.414 5l-10 10z' fill='%23fff' fill-rule='nonzero'/%3E%3C/svg%3E ");
	        background-repeat: no-repeat;
	        background-position: 2px 3px;
	        border-radius: 50%;
	        z-index: 2;
	        position: absolute;
	        right: 10px;
	        top: 50%;
	        transform: translateY(-50%);
	        cursor: pointer;
	        transition: all 200ms ease-in;
	      }
	    }

	    input:checked ~ label {
	      color: #000;

	      &:before {
	        transform: translate(-50%, -50%) scale3d(56, 56, 1);
	      }

	      &:after {
	        background-color: #54E0C7;
	        border-color: #54E0C7;
	      }
	    }

	    input {
	      width: 32px;
	      height: 32px;
	      order: 1;
	      z-index: 2;
	      position: absolute;
	      right: 30px;
	      top: 50%;
	      transform: translateY(-50%);
	      cursor: pointer;
	      visibility: hidden;
	    }
  }



  .inputGroup2 {
	    background-color: #fff;
	    border: 1px solid #D1D7DC;
	    display: block;
	    margin: 0;
	    position: relative;
	    width: 100%;
	    label {
	      padding: 12px 10px;
	      width: 100%;
	      display: block;
	      text-align: left;
	      margin-bottom: 0 !important;
	      color: #3C454C;
	      font-size: 15px;
	      font-family: 'Poppins', sans-serif;
	      cursor: pointer;
	      position: relative;
	      z-index: 2;
	      transition: color 200ms ease-in;
	      overflow: hidden;

	      &:before {
	        width: 10px;
	        height: 10px;
	        border-radius: 50%;
	        content: '';
	        background-color: #5562eb;
	        position: absolute;
	        left: 50%;
	        top: 50%;
	        transform: translate(-50%, -50%) scale3d(1, 1, 1);
	        transition: all 300ms cubic-bezier(0.4, 0.0, 0.2, 1);
	        opacity: 0;
	        z-index: -1;
	      }

	      &:after {
	        width: 32px;
	        height: 32px;
	        content: '';
	        border: 2px solid #D1D7DC;
	        background-color: #fff;
	        background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.414 11L4 12.414l5.414 5.414L20.828 6.414 19.414 5l-10 10z' fill='%23fff' fill-rule='nonzero'/%3E%3C/svg%3E ");
	        background-repeat: no-repeat;
	        background-position: 2px 3px;
	        border-radius: 50%;
	        z-index: 2;
	        position: absolute;
	        right: 10px;
	        top: 50%;
	        transform: translateY(-50%);
	        cursor: pointer;
	        transition: all 200ms ease-in;
	      }
	    }

	    input:checked ~ label {
	      color: #000;

	      &:before {
	        transform: translate(-50%, -50%) scale3d(56, 56, 1);
	      }

	      &:after {
	        background-color: #54E0C7;
	        border-color: #54E0C7;
	      }
	    }

	    input {
	      width: 32px;
	      height: 32px;
	      order: 1;
	      z-index: 2;
	      position: absolute;
	      right: 30px;
	      top: 50%;
	      transform: translateY(-50%);
	      cursor: pointer;
	      visibility: hidden;
	    }
  }
  .first-question{
  	font-family: 'Poppins', sans-serif;
    font-size: 17px;
    font-weight: 500;
  }

  .first-question2{
  	font-family: 'Poppins', sans-serif;
    font-size: 15px;
    font-weight: 500;
  }

  .header-send{
  	width: 100%;
  	display: flex;
  	justify-content: space-between;
  	align-items: center;
  	padding-bottom: 20px;
  }

  .header-send i{
  	font-size: 21px;
	color: #676767;
	margin-bottom: .5rem;
	align-self: center;
	font-weight: 600 !important;
  }

  .header-send h4{
  	font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 500;
  }

  .header-get{
  	width: 100%;
  	display: flex;
  	justify-content: space-between;
  	align-items: center;
  	padding-bottom: 20px;
  }

  .header-get i{
  	font-size: 21px;
	color: #676767;
	margin-bottom: .5rem;
	align-self: center;
	font-weight: 600 !important;
  }

  .header-get h4{
  	font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 500;
  }

  .header-deliver{
  	width: 100%;
  	display: flex;
  	justify-content: space-between;
  	align-items: center;
  	padding-bottom: 20px;
  }

  .header-deliver i{
  	font-size: 21px;
	color: #676767;
	margin-bottom: .5rem;
	align-self: center;
	font-weight: 600 !important;
  }

  .header-deliver h4{
  	font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 500;
  }

  	.checkbox3{
		width: 100%;
	}

	.checkbox4{
		width: 100%;
	}

	.second-question{
		font-family: 'Poppins', sans-serif;
   		font-size: 17px;
   	 	font-weight: 500;
   	 	padding-top: 15px;
   	 	padding-bottom: 7px;
	}

	.payment-way{
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		background: #fff;
		/*border-top-left-radius: 30px;
		border-bottom-right-radius: 30px;
		border-bottom-left-radius: 30px;*/
		border: 1px solid #cccccc;
		padding: 4px;
		margin-top: 1px;
		margin-bottom: 15px;
	}

	.pay-icon{
		width: 46px;
		height: 46px;
		/*border-radius: 50%;*/
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.pay-icon i{
		color: #fff;
	}

	.pay-select{
		width: 90%;
	}

	.pay-select select{
		width: 100%;
		padding-top: 12px;
		padding-bottom: 12px;
		padding-left: 8px;
		padding-right: 19px;
		cursor: pointer;
		color: #757575;
		background: transparent;
		border: none;
		appearance: none;
		-webkit-appearance: none;
		background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
		background-repeat: no-repeat;
		background-size: 28px;
		background-position-x: 100%;
	  	background-position-y: 12px;
	}


</style>

<script>
	import axios from 'axios';
	export default{
		props: ['message'],
		data(){
			return {
				forma_pago: 0,
				success: false,
				transer_state: false,
				bank_transfer: false,
				get_state: false,
				buy_state: false,
				programado_state: false,
				direction_get_list: localStorage.getItem('get_address') ? localStorage.getItem('get_address').split(',') : [],
				direction_list: localStorage.getItem('direction_list') ? localStorage.getItem('direction_list').split(',') : [],
				status_option: false,
				programado: false,
				status_send:false,
				status_get: false,
				status_delivery: false,	
				status_other: false,
				bank_account: JSON.parse(localStorage.getItem('banks_accounts')),
				status_email: JSON.parse(localStorage.getItem('r_email')),
				color_licencia: localStorage.getItem('color_licencia'),
				cash: JSON.parse(localStorage.getItem('cash')),
				transfer: JSON.parse(localStorage.getItem('transfer')),
				dataphone: JSON.parse(localStorage.getItem('dataphone')),
				number_guide: localStorage.getItem('number_guide'),
				id_companie: localStorage.getItem('companie_id'),
				id_point: localStorage.getItem('id_point'),
				mensaje:'',
				latitude: null,
				longitude: null,
				send_form: {
					go_and_back: false,
					no_go_and_back: false,
					inmediatly: false,
					payment_way: 0,
					deliver_date: "",
					deliver_hour: "",
					additional_info: "",
					recogida_persona: "",
					recogida_direccion: "",
					where_persona: "",
					where_direccion: "",
					recogida_telefono:"",
					where_telefono: "",
					recogida_email: ""
				},
				get_form:{
					get_name: "",
					get_phone: "",
					get_email: "",
					get_address: "",
					more_details: "",
					place_address:"",
					who_asked: "", 
					hour: "",
					date: "",
					payment_id: 0
				},
				buy_form:{
					buy_name:"",
					buy_phone: "",
					where_buy: "",
					buy_order: "",
					buy_address: "",
					buy_price: "",
					buy_info: "",
					b_date: "",
					b_hour:"",
					id_payment: 0
				},
				form_other:{
					other_service: "",
					other_name: "",
					other_phone: ""
				},
				formasPago:[
		          {id: 37, text: 'Efectivo'},
		          {id: 38, text: 'Transferencia'},
		          {id: 39, text: 'Datáfono'}
		        ]
			}
		},
		watch:{
			
		},
		methods:{
			copyAccount(){
				this.success = true;
				setTimeout(function(){
					this.success = false;
				},2000);                 
		        var aux = document.createElement("input");
		        aux.setAttribute("value", document.getElementById('select-bank').value);
		        document.body.appendChild(aux);
		        aux.select();
		        document.execCommand("copy");
		        document.body.removeChild(aux);  
    		},
			payment(){
				if(this.send_form.payment_way == 38){
					this.bank_transfer =true;
				}else{
					this.bank_transfer = false;
				}
				if (this.get_form.payment_id == 38) {
					this.get_state = true;
				}else{
					this.get_state = false;
				}
				if (this.buy_form.id_payment == 38) {
					this.transer_state = true;
				}else{
					this.transer_state = false;
				}
			},
			Close(){
				if (localStorage.getItem('id_delivery')) {
					this.$emit('closeCheckoutDelivery', false);
				}else{
					this.$emit('closeCheckout', false);
				}
                
            },
            setDirectionList(){
            	if (localStorage.getItem('envio')) {
            		let local_envio = JSON.parse(localStorage.getItem('envio'));
            		this.direction_list.push(local_envio.where_direccion);
            		localStorage.setItem('direction_list', this.direction_list);
            	}
            },
            DirectionGetForm(){
            	if (localStorage.getItem('get_direction')) {
            		let get_envio = JSON.parse(localStorage.getItem('get_direction'));
            		this.direction_get_list.push(get_envio.place_address);
            		localStorage.setItem('get_address', this.direction_get_list);
            	}
            },
            verifyBuy(){
            	let isChecked = document.getElementById('select5').checked;
            	if (isChecked) {
            		this.buy_state = true;
            	}else{
            		this.buy_state = false;
            	}
            },
            hideFields(){
            	let isChecked = document.getElementById('select4').checked;
            	if (isChecked) {
            		this.programado_state = true;
            	}else{
            		this.programado_state = false;
            	}
            },
            validateCheck(){
            	let isChecked = document.getElementById('select').checked;
            	if (isChecked) {
            		this.programado = true;
            	}else{
            		this.programado = false;
            	}
            },
            validateSend(){
            	let isChecked = document.getElementById('select2').checked;
            	if (isChecked) {
            		this.send_form.go_and_back = true;
            	}else{
            		this.send_form.no_go_and_back = true;
            	}
            },
            validateOptions(){
            	let isChecked = document.getElementById('select3').checked;
            	if (isChecked) {
            		this.status_option = true;
            	}else{
            		this.status_option = false;
            	}
            },
            ValidateForm(){
            	let product = this.message;
            	if (product.id_type_service == 79)this.status_send = true;
            	if (product.id_type_service == 80)this.status_get = true;
            	if (product.id_type_service == 81)this.status_delivery = true;
            	if (product.id_type_service == 82)this.status_other = true;
            },
            sendWhatsApp(){
            	let product = this.message;
            	if (product.id_type_service == 79){
            		//Enviar a whatsapp: estructura de enviar algo
	            	this.mensaje = "";
	            	let nombre_comercial = localStorage.getItem('nombre_comercial');
	            	let telefono_pedidos = localStorage.getItem('telefono_pedidos');
	            	nombre_comercial = nombre_comercial.replace(" ","%20");
	            	this.mensaje += `https://wa.me/${telefono_pedidos}?text=Hola%20${nombre_comercial}%20me%20gustaria%20realizar%20un%20envio.`;
	            	//espacio en blanco
	            	this.mensaje += '%0A%0A';
	            	this.mensaje += `*Numero de guia:*%20${this.number_guide}`;
	            	this.mensaje += '%0A';
	            	this.mensaje += `*Lugar de recogida*`;
	            	this.mensaje += '%0A';
	            	this.mensaje += `*Preguntar por:*%20${this.send_form.recogida_persona}`;
	            	this.mensaje += '%0A';
	            	let aux_direct = this.send_form.recogida_direccion
	            	aux_direct = aux_direct.replace("#", '%23');
	            	this.mensaje += `*Dirección:*%20${aux_direct}`;
	            	this.mensaje += '%0A';
	            	this.mensaje += `*Teléfono:*%20${this.send_form.recogida_telefono}`;
	            	this.mensaje += '%0A';
	            	if (this.status_email) {
	            		this.mensaje += `*Email:*%20${this.send_form.recogida_email}`;
	            		this.mensaje += '%0A';
	            	}
	            	this.mensaje += `*¿A donde se lleva?*`
	            	this.mensaje += '%0A';
	            	this.mensaje += `*Preguntar por:*%20${this.send_form.where_persona}`;
	            	this.mensaje += '%0A';
	            	let direccion = this.send_form.where_direccion;
	            	direccion = direccion.replace("#", '%23');
	            	this.mensaje += `*Dirección:*%20${direccion}`;
	            	this.mensaje += '%0A';
	            	this.mensaje += `*Teléfono:*%20${this.send_form.where_telefono}`;
	            	this.mensaje += '%0A';
	            	/*if (this.send_form.inmediatly) {
	            		this.mensaje += `*Disponibilidad:*%20Inmediata`;
	            	}else{
	            		this.mensaje += `*Disponibilidad:*%20Fecha programada`;
	            		this.mensaje += '%0A';
	            		this.mensaje += `*Fecha de entrega:*%20${this.send_form.deliver_date}`;
	            		this.mensaje += '%0A';
	            		this.mensaje += `*Hora de entrega:*%20${this.send_form.deliver_hour}`;
	            	}*/
	            	if (this.programado) {
	            		this.mensaje += `*Disponibilidad:*%20Fecha programada`;
	            		this.mensaje += '%0A';
	            		this.mensaje += `*Fecha de entrega:*%20${this.send_form.deliver_date}`;
	            		this.mensaje += '%0A';
	            		this.mensaje += `*Hora de entrega:*%20${this.send_form.deliver_hour}`;
	            	}else{
	            		this.mensaje += `*Disponibilidad:*%20Inmediata`;
	            	}
	            	this.mensaje += '%0A';
	            	let forma_pago = this.send_form.payment_way;
	            	this.formasPago.forEach(function(f){
				        if(forma_pago == f.id)forma_pago = f.text;
				    });
	            	this.mensaje += `*Método de pago:*%20${forma_pago}`;
	            	this.mensaje += '%0A';
	            	this.mensaje += `*Información adicional:*%20${this.send_form.additional_info}`;
	            	this.mensaje += '%0A';
	            	if (this.send_form.go_and_back) {
	            		this.mensaje += `*¿Es ida y vuelta?:*%20Si`;
	            	}else{
	            		this.mensaje += `*¿Es ida y vuelta?:*%20No`;
	            	}
	            	this.mensaje += '%0A';
	            	this.mensaje += `Gracias.`;
	            	localStorage.setItem('envio', JSON.stringify(this.send_form));
	            	this.setDirectionList();
	            	location.href = this.mensaje;
            	}
            	if (product.id_type_service == 80){
            		//Enviar a whatsapp: estructura de recoger algo
	            	this.mensaje = "";
	            	let nombre_comercial = localStorage.getItem('nombre_comercial');
	            	let telefono_pedidos = localStorage.getItem('telefono_pedidos');
	            	nombre_comercial = nombre_comercial.replace(" ","%20");
	            	this.mensaje += `https://wa.me/${telefono_pedidos}?text=Hola%20${nombre_comercial}%20me%20gustaria%20solicitar%20un%20servicio%20de%20recogida.`;
	            	//espacio en blanco
	            	this.mensaje += '%0A%0A';
	            	this.mensaje += `*Numero de guia:*%20${this.number_guide}`;
	            	this.mensaje += '%0A';
	            	this.mensaje += `*Nombres:*%20${this.get_form.get_name}`;
	            	this.mensaje += '%0A';
	            	this.mensaje += `*Teléfono:*%20${this.get_form.get_phone}`;
	            	this.mensaje += '%0A';
	            	if (this.status_email) {
	            		this.mensaje += `*Email:*%20${this.get_form.get_email}`;
	            	}
	            	this.mensaje += '%0A';
	            	let direccion = this.get_form.get_address;
	            	direccion = direccion.replace("#", '%23');
	            	this.mensaje += `*Dirección de recogida:*%20${direccion}`;
	            	this.mensaje += '%0A';
	            	this.mensaje += `*¿A donde se lleva?:*`;
	            	this.mensaje += '%0A';
	            	let get_adress_aux = this.get_form.place_address;
	            	get_adress_aux = get_adress_aux.replace("#", '%23');
	            	this.mensaje += `*Dirección:*%20${get_adress_aux}`;
	            	this.mensaje += '%0A';
	            	this.mensaje += `*Preguntar por:*%20${this.get_form.who_asked}`;
	            	this.mensaje += '%0A';
	            	let forma_pago = this.get_form.payment_id;
	            	this.formasPago.forEach(function(f){
				        if(forma_pago == f.id)forma_pago = f.text;
				    });
	            	this.mensaje += `*Método de pago:*%20${forma_pago}`;
	            	this.mensaje += '%0A';
	            	/*this.mensaje += `*Donde quieres comprar:*%20${this.get_form.buy_place}`;
	            	this.mensaje += '%0A';*/
	            	if (this.programado_state) {
	            		this.mensaje += `*Disponibilidad:*%20Fecha programada`;
	            		this.mensaje += '%0A';
	            		this.mensaje += `*Fecha de entrega:*%20${this.get_form.date}`;
	            		this.mensaje += '%0A';
	            		this.mensaje += `*Hora de entrega:*%20${this.get_form.hour}`;
	            		this.mensaje += '%0A';
	            	}
	            	if(!this.programado_state){
	            		this.mensaje += `*Disponibilidad:*%20Inmediata`;
	            		this.mensaje += '%0A';
	            	}
	            	if (this.get_form.more_details) {
	            		this.mensaje += `*Mas detalles:*%20${this.get_form.more_details}`;	
	            	}
	            	this.mensaje += '%0A';
	            	this.mensaje += `Gracias.`;
	            	localStorage.setItem('get_direction', JSON.stringify(this.get_form));
	            	this.DirectionGetForm();
	            	location.href = this.mensaje;
            	}
            	if (product.id_type_service == 81){
            		//Enviar a whatsapp: estructura de comprar algo
	            	this.mensaje = "";
	            	let nombre_comercial = localStorage.getItem('nombre_comercial');
	            	let telefono_pedidos = localStorage.getItem('telefono_pedidos');
	            	nombre_comercial = nombre_comercial.replace(" ","%20");
	            	this.mensaje += `https://wa.me/${telefono_pedidos}?text=Hola%20${nombre_comercial}%20me%20gustaria%20solicitar%20un%20servicio%20de%20compra.`;
	            	//espacio en blanco
	            	this.mensaje += '%0A%0A';
	            	this.mensaje += `*Numero de guia:*%20${this.number_guide}`;
	            	this.mensaje += '%0A';
	            	this.mensaje += `*Nombres:*%20${this.buy_form.buy_name}`;
	            	this.mensaje += '%0A';
	            	this.mensaje += `*Teléfono:*%20${this.buy_form.buy_phone}`;
	            	this.mensaje += '%0A';
	            	let buy_place = this.buy_form.where_buy;
	            	buy_place = buy_place.replace("#", '%23');
	            	this.mensaje += `*¿Donde compramos?:*%20${buy_place}`;
	            	this.mensaje += '%0A';
	            	this.mensaje += `*¿Que vamos a comprar?:*%20${this.buy_form.buy_order}`;
	            	this.mensaje += '%0A';
	            	this.mensaje += `*¿Precio aproximado?:*%20${this.buy_form.buy_price}`;
	            	this.mensaje += '%0A';
	            	let direccion = this.buy_form.buy_address;
	            	direccion = direccion.replace("#", '%23');
	            	this.mensaje += `*¿Donde te lo llevamos?:*%20${direccion}`;
	            	this.mensaje += '%0A';
	            	if (this.buy_state) {
	            		this.mensaje += `*Disponibilidad:*%20Fecha programada`;
	            		this.mensaje += '%0A';
	            		this.mensaje += `*Fecha de entrega:*%20${this.buy_form.b_date}`;
	            		this.mensaje += '%0A';
	            		this.mensaje += `*Hora de entrega:*%20${this.buy_form.b_hour}`;
	            		this.mensaje += '%0A';
	            	}
	            	if(!this.buy_state){
	            		this.mensaje += `*Disponibilidad:*%20Inmediata`;
	            		this.mensaje += '%0A';
	            	}
	            	this.mensaje += '%0A';
	            	let forma_pago = this.buy_form.id_payment;
	            	this.formasPago.forEach(function(f){
				        if(forma_pago == f.id)forma_pago = f.text;
				    });
	            	this.mensaje += `*Método de pago:*%20${forma_pago}`;
	            	this.mensaje += '%0A';
	            	if (this.buy_form.buy_info) {
	            		this.mensaje += `*Observaciones adicionales:*%20${this.buy_form.buy_info}`;	
	            	}
	            	this.mensaje += '%0A';
	            	this.mensaje += `Gracias.`;
	            	location.href = this.mensaje;
            	}
            	if (product.id_type_service == 82){
            		//Enviar a whatsapp: estructura de otro servicio
	            	this.mensaje = "";
	            	let nombre_comercial = localStorage.getItem('nombre_comercial');
	            	let telefono_pedidos = localStorage.getItem('telefono_pedidos');
	            	nombre_comercial = nombre_comercial.replace(" ","%20");
	            	this.mensaje += `https://wa.me/${telefono_pedidos}?text=Hola%20${nombre_comercial}%20me%20gustaria%20solicitar%20otro%20tipo%20de%20servicio.`;
	            	this.mensaje += '%0A%0A';
	            	this.mensaje += `*Numero de guia:*%20${this.number_guide}`;
	            	this.mensaje += '%0A';
	            	this.mensaje += `*Nombres:*%20${this.form_other.other_name}`;
	            	this.mensaje += '%0A';
	            	this.mensaje += `*Telefono:*%20${this.form_other.other_phone}`;
	            	this.mensaje += '%0A';
	            	this.mensaje += `*Descripcion:*%20${this.form_other.other_service}`;
	            	this.mensaje += '%0A';
	            	this.mensaje += `Gracias.`;
	            	location.href = this.mensaje; 
            	}
            },
            saveBD(){
            	let product = this.message;
            	var form;
            	var _self = this;
            	if (product.id_type_service == 79) {
            		form = this.send_form;
            		this.forma_pago = this.send_form.payment_way;
            	}
            	if (product.id_type_service == 80) {
            		form = this.get_form;
            		this.forma_pago = this.get_form.payment_id;
            	}
            	if (product.id_type_service == 81) {
            		form = this.buy_form;
            		this.forma_pago = this.buy_form.id_payment;
            	}
            	if (product.id_type_service == 82) {
            		form = this.form_other;
            	}
            	form["id_type_forma_pago"] = this.forma_pago;
            	form["id_companie"] = this.id_companie;
            	form["latitud"] = this.latitude;
            	form["longitud"] = this.longitude;
            	form["id_type_service"] = product.id_type_service;
            	form["total"] = product.value_sale;
            	form["id_product"] = product.id;
            	form["id_point"] = this.id_point;
            	form["number_guide"] = this.number_guide;
            	axios.post('https://back.vinapp.co/api/order/save-order-mensajeria',form)
			    .then(res => {
			    	if(res.data.status == 200)_self.sendWhatsApp();
			    })
			    .catch(err => {
			        console.log(err);      
			    });
            }
		},
		mounted(){
			//document.getElementById('transfer-text').style.display = 'none';
			//$(".transfer-container").addClass("hide");
			var self = this;
            this.ValidateForm();
            const ubicacion_success = function(ubicacion) {
	          console.log(ubicacion)
	          if (ubicacion) {
	            const lat = ubicacion.coords.latitude;
	            const lng = ubicacion.coords.longitude;        
	            self.latitude = lat;
	            self.longitude = lng;
	          }
        	}
	        const ubicacion_error = function(error) {          
	          console.log(error)
	        }   
	        //solo para domicilios
	        if(navigator.geolocation) {
	          navigator.geolocation.getCurrentPosition(ubicacion_success,ubicacion_error);
	        }
		}
	}
</script>